import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { Button } from 'components/shared';
import { useCustomerContext } from 'contexts/Customer';
import logoSosedi from 'img/logoSosedi.png';
import { HeaderAddress } from './HeaderAddress';
import { HeaderCart } from './HeaderCart';
import { HeaderDelivery } from './HeaderDelivery';
import { HeaderDesktopMenu } from './HeaderDesktopMenu';
import { HeaderMobileMenu } from './HeaderMobileMenu';
import styles from './Header.module.scss';

const Header = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { customer } = useCustomerContext();

  return (
    <header className={styles.root}>
      {pathname.includes('mobile-app') ? (
        <div className={styles.content}>
          <Link to="/">
            <img src={logoSosedi} alt="SosediLogo" width={142} height={41} />
          </Link>
        </div>
      ) : (
        <div className={styles.content}>
          <nav className={styles.side}>
            <Link to="/">
              <img src={logoSosedi} alt="SosediLogo" width={142} height={41} />
            </Link>
            <Link className={styles.link} to="/">
              {t('main:header.links.0')}
            </Link>
          </nav>

          <div className={styles.side}>
            <HeaderDelivery className={styles.desktopOnly} />
            <HeaderAddress className={styles.desktopOnly} />

            <HeaderCart />
            <HeaderMobileMenu />

            <div className={styles.desktopOnly}>
              {customer ? (
                <HeaderDesktopMenu />
              ) : (
                <Link to="/login" onClick={() => sessionStorage.setItem('redirectUrl', pathname)}>
                  <Button>{t('main:header.login')}</Button>
                </Link>
              )}
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
